import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5f1b0747"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title-issue" }
const _hoisted_2 = { class: "date-picker-issue" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "el-icon el-icon-search fas" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "el-icon el-icon-filter fas" }, null, -1))
const _hoisted_5 = { class: "header-filter" }
const _hoisted_6 = { class: "header-filter" }
const _hoisted_7 = { class: "header-filter" }
const _hoisted_8 = { class: "table-wrapper" }
const _hoisted_9 = { class: "list-buttons" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "el-icon el-icon-plus fas" }, null, -1))

import { onMounted, ref, reactive, computed } from "vue";
import { getImageLossAlert } from "@/service/imagelossalert.service.ts";
import issueList from "@/components/issueMonitoring/issueList.component";
import {
  SamplingPointImageStatus,
  ImageLossAlert,
  IssueType,
  IssueSubType,
} from "@/types/issueMonitoring.type.ts";
import { Filter } from "@/types/filter.type";
import { Pagination } from "@/types/pagination.type";
import issueFormComponent from "@/components/issueMonitoring/issueForm.component";
import { useRoute } from "vue-router";
import { getIssueType } from "@/service/issueType.service.ts";
import { getSamplingPointsImageStatus } from "@/service/samplingPointImageStatus.service.ts";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute();
const optionsPoint = ref<SamplingPointImageStatus>([]);
const imageLossAlert = ref<Pagination<ImageLossAlert>>([]);
const visibleSearch = ref(false);
const issueType = ref<IssueType>([]);
// - pagination
const page = ref(1);
const size = ref(10);

const pointId = computed(() => route.query.point);
// newIssue
const dialogTableVisible = ref(false);

const filters = reactive({
  date: [null, null],
  filterType: {} as IssueType,
  filterSubType: {} as IssueSubType,
  namePoint: {} as SamplingPointImageStatus,
  origin: "",
});

const options = [
  {
    value: "AUTOMATIC",
    label: "Automático",
  },
  {
    value: "MANUAL",
    label: "Manual",
  },
];

onMounted(async () => {
  getLast24h();

  //- Incidencias
  await searchFilter();

  issueType.value = await getIssueType();
  const filter: Filter = {
    fields: {
      "samplingpointimagestatus.stationOperation": { operator: "equal", value: true },
    },
  };
  const samplingPointListStatus = (await getSamplingPointsImageStatus(undefined, undefined, filter))
    .data;

  optionsPoint.value = new Set([...samplingPointListStatus]);

  filters.namePoint = [...optionsPoint.value].find((p) => p.samplingPoint.id == pointId.value);
});

// - METHODS
/**
 * Recuperar la fecha desde las últimas 24 horas
 */
const getLast24h = () => {
  filters.date[1] = new Date();
  filters.date[1].setHours(8, 30, 0, 0);

  // AYER a las 08:30
  filters.date[0] = new Date(filters.date[1]);
  filters.date[0].setDate(filters.date[1].getDate() - 1);
};

/**
 * Recuperar las incidencias según los filtro configurados
 */
const searchFilter = async () => {
  const fields: Record<string, any> = {};

  if (filters?.filterType?.id) {
    fields["imageLossAlert.type"] = {
      operator: "equal",
      value: filters.filterType.id,
    };
  }

  if (filters?.filterSubType?.id) {
    fields["imageLossAlert.subType"] = {
      operator: "equal",
      value: filters.filterSubType.id,
    };
  }

  if (filters?.origin) {
    fields["imageLossAlert.origin"] = {
      operator: "equal",
      value: filters.origin,
    };
  }

  if (filters?.namePoint?.samplingPoint?.id) {
    fields["imageLossAlert.samplingPoint"] = {
      operator: "equal",
      value: filters.namePoint.samplingPoint.id,
    };
  }

  if (pointId.value !== undefined) {
    fields["samplingPoint.id"] = {
      operator: "equal",
      value: Number(pointId.value),
    };
  }

  fields["sis.stationOperation"] = {
    operator: "equal",
    value: true,
  };

  const filter: Filter = { fields };

  imageLossAlert.value = await getImageLossAlert(
    page.value,
    size.value,
    filters.date[0],
    filters.date[1],
    filter
  );
};

/**
 * Actualizar filtros
 */
const updateFilter = () => {
  filters.filterSubType = {} as IssueSubType;
};

//- PAGINATION
/**
 * change page
 * @param v
 */
const changePage = async (v: number) => {
  page.value = v;
  await searchFilter();
};

/**
 * change size
 * @param v
 */
const changeSize = async (v: number) => {
  size.value = v;
  await searchFilter();
};

//- FORM
const addIssue = async () => {
  imageLossAlert.value = {};
  await searchFilter();
};

const saveIssue = () => {
  dialogTableVisible.value = true;
};

const closeAddIssue = () => {
  dialogTableVisible.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_page_buttons_component = _resolveComponent("page-buttons-component")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createVNode(_component_el_card, {
        class: "header-import page-title",
        style: {"margin-bottom":"5px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_row, { class: "header-issue" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("h3", null, _toDisplayString(_ctx.$t("label.issue_list")), 1)
              ]),
              _createElementVNode("div", _hoisted_2, [
                (_openBlock(), _createBlock(_component_el_date_picker, {
                  modelValue: _unref(filters).date[0],
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(filters).date[0]) = $event)),
                  type: "datetime",
                  style: {"width":"50%"},
                  format: "YYYY-MM-DD HH:mm",
                  placeholder: "DD/MM/AAAA hh:mm",
                  key: 'from' + _ctx.dateKey
                }, null, 8, ["modelValue"])),
                (_openBlock(), _createBlock(_component_el_date_picker, {
                  modelValue: _unref(filters).date[1],
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(filters).date[1]) = $event)),
                  type: "datetime",
                  style: {"width":"50%"},
                  format: "YYYY-MM-DD HH:mm",
                  placeholder: "DD/MM/AAAA hh:mm",
                  key: 'from' + _ctx.dateKey
                }, null, 8, ["modelValue"])),
                _createVNode(_component_el_button, {
                  type: "primary",
                  size: "small",
                  onClick: searchFilter
                }, {
                  default: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_popover, {
                  placement: "bottom",
                  width: 250,
                  visible: visibleSearch.value,
                  "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((visibleSearch).value = $event))
                }, {
                  reference: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      size: "small",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (visibleSearch.value = !visibleSearch.value))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_4
                      ]),
                      _: 1
                    })
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t("parameterType.samplingpoint")), 1),
                    _createVNode(_component_el_select, {
                      modelValue: _unref(filters).namePoint,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(filters).namePoint) = $event)),
                      filterable: "",
                      class: "select-filter",
                      "value-key": "id",
                      clearable: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(optionsPoint.value, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item,
                            label: item.samplingPoint.name,
                            value: item
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t("label.issueDescription")), 1),
                    _createVNode(_component_el_select, {
                      modelValue: _unref(filters).filterType,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(filters).filterType) = $event)),
                      "value-key": "name",
                      class: "select-filter",
                      onChange: _cache[5] || (_cache[5] = ($event: any) => (updateFilter())),
                      filterable: "",
                      clearable: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(issueType.value, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item,
                            label: item.name,
                            value: item
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_el_select, {
                      modelValue: _unref(filters).filterSubType,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(filters).filterSubType) = $event)),
                      class: "select-filter",
                      "value-key": "name",
                      filterable: "",
                      clearable: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filters).filterType?.subTypes, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item,
                            label: item.name,
                            value: item
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t("label.issueAutomaticManual")), 1),
                    _createVNode(_component_el_select, {
                      modelValue: _unref(filters).origin,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(filters).origin) = $event)),
                      placeholder: "Select",
                      style: {"width":"240px"},
                      filterable: "",
                      clearable: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(options, (item) => {
                          return _createVNode(_component_el_option, {
                            key: item.value,
                            label: item.label,
                            value: item.value
                          }, null, 8, ["label", "value"])
                        }), 64))
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_el_row, { class: "btn" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          type: "primary",
                          onClick: searchFilter
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("btn.search")), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["visible"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_card, { class: "card-issue" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_unref(issueList), {
              pagination: imageLossAlert.value,
              onChangePage: _cache[9] || (_cache[9] = ($event: any) => (changePage($event))),
              onChangeSize: _cache[10] || (_cache[10] = ($event: any) => (changeSize($event))),
              onPushIssueList: addIssue
            }, null, 8, ["pagination"])
          ])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_page_buttons_component, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_tooltip, {
            class: "box-item",
            effect: "dark",
            content: _ctx.$t('btn.create'),
            placement: "left"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                class: "btn",
                type: "primary",
                size: "large",
                onClick: saveIssue,
                circle: ""
              }, {
                default: _withCtx(() => [
                  _hoisted_10
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["content"])
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: dialogTableVisible.value,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((dialogTableVisible).value = $event)),
      title: _ctx.$t('title.newIssue'),
      width: "80%"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(issueFormComponent), {
          onClose: closeAddIssue,
          onGetIssue: addIssue
        })
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ]))
}
}

})